const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  SET_PAGE_INFO: "SET_PAGE_INFO",
};

export const initialState = {
  pagesInfo: {},
};

export const actions = {
  setPageInfo: (data) => ({
    type: types.SET_PAGE_INFO,
    data,
  })
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      return {
        ...state,
        ...action.payload.page,
      }
    }
    case types.SET_PAGE_INFO:
      let category = 'header'; 
      // a futuro se podria meter aqui orion... y ascosas de pagina como debió ser desde le principio...
      const { location, info, category: payloadCategory } = action.data;
      if (payloadCategory) {
        category = payloadCategory;
      };
      let newState = {...state }
      try {
        if (newState && !newState.pagesInfo[location]){
          newState.pagesInfo[location] = {}
        }
        if (newState && !newState.pagesInfo[location][category]) {
          newState.pagesInfo[location][category] = {}
        }
  
        newState.pagesInfo[location][category] = info

      } catch(e) {
        console.error(e)
      }

      return {
        ...state,
        ...newState,
      }
    default:
    return {...state};
  }
}

export default reducer;
